import React from "react";
import DetailsModal from "../../../components/ModalDetailsGeneric/ModalDetailsGeneric";
import { CustomButtonVariant } from "../../../components/CustomButton/CustomButton";
import { TableRow } from "../models/default";

interface DetailsModalTableProps {
  open: boolean;
  onClose: () => void;
  modalData: TableRow | null;
}

const DetailsModalTable: React.FC<DetailsModalTableProps> = ({
  open,
  onClose,
  modalData,
}) => {
  return (
    <DetailsModal
      open={open}
      onClose={onClose}
      title="Detalhes do pedido de bombeio"
      header={{
        title: modalData?.customer || "",
      }}
      data={[
        {
          label: "N. do agendamento",
          value: modalData?.scheduleNumber,
        },
        {
          label: "Filial",
          value: modalData?.subsidiary,
        },
        {
          label: "Produto",
          value: modalData?.product,
        },
        {
          label: "Modalidade",
          value: modalData?.mod,
        },
        {
          label: "Quantidade",
          value: modalData ? `${modalData.quantity}${modalData.unit}` : "-",
        },
        {
          label: "Condição de pagamento",
          value: modalData?.paymentCondition,
        },
        {
          label: "Data para bombeio",
          value: modalData?.scheduleDate,
        },
        {
          label: "Horário",
          value: modalData?.scheduleTime,
        },
        {
          label: "Data do pedido",
          value: modalData?.createdAt,
        },
        {
          label: "Solicitado por",
          value: modalData?.customerRequester,
        },
        {
          label: "Observação",
          value: modalData?.customerRequesterNote || "-",
          fullWidth: true,
        },
      ]}
      actions={[
        {
          label: "Fechar",
          variant: CustomButtonVariant.CONTAINED,
          onClick: onClose,
        },
      ]}
    />
  );
};

export default DetailsModalTable;
